import { createFileRoute } from '@tanstack/react-router'

import NotFound from '@/shared/NothingFound'
import { RouteErrorComponent } from '@/shared/RouteErrorComponent/RouteErrorComponent.tsx'

export const Route = createFileRoute('/$')({
    component: RouteComponent,
    onError: RouteErrorComponent,
})

function RouteComponent() {
    return <NotFound />
}
